import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200" };
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_3 = { class: "space-y-6 pt-8 sm:space-y-5 sm:pt-10" };
const _hoisted_4 = { class: "space-y-6 sm:space-y-5" };
const _hoisted_5 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2" }, "Active", -1);
const _hoisted_7 = { class: "mt-4" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("legend", { class: "sr-only" }, "Region Active Status", -1);
const _hoisted_9 = { class: "mr-2 flex flex-row align-center" };
const _hoisted_10 = ["id", "value", "name", "checked"];
const _hoisted_11 = ["for"];
const _hoisted_12 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", {
    for: "kronos-region-id",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "ID", -1);
const _hoisted_14 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_15 = ["disabled"];
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "text-red-600" };
const _hoisted_18 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("label", {
    for: "kronos-region-label",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "Display name", -1);
const _hoisted_20 = { class: "mt-1 sm:col-span-2 sm:mt-0" };
const _hoisted_21 = ["disabled"];
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Shown to users in the Amend form (e.g. division name).", -1);
const _hoisted_23 = { key: 0 };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "my-8" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg text-center" }, "Contracts")
], -1);
const _hoisted_25 = { class: "flex justify-end my-4" };
const _hoisted_26 = {
    key: 0,
    class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
};
const _hoisted_27 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_28 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { class: "relative whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-700 sm:pl-6 hover:underline" };
const _hoisted_31 = {
    key: 0,
    class: "text-red-700 border rounded-md px-2 border-red-700 absolute right-8"
};
const _hoisted_32 = {
    key: 1,
    class: "text-lg text-center text-gray-600"
};
const _hoisted_33 = {
    key: 1,
    class: "text-lg text-center text-gray-600"
};
const _hoisted_34 = { class: "pt-5" };
const _hoisted_35 = { class: "flex justify-end" };
const _hoisted_36 = ["disabled"];
import { ClockIcon } from '@heroicons/vue/solid';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import KronosContractForm from '@/components/admin/admin-components/config/forms/KronosContractForm.vue';
import ModalWindow from '@/components/ModalWindow.vue';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'KronosRegionForm',
    props: {
        selectedItem: {}
    },
    emits: ["close-modal", "refresh-config"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const store = useStore();
        const showContractModal = ref(false);
        const selectedContract = ref(undefined);
        const formData = reactive({
            LKStatus: true,
            ID: '',
            Label: '',
        });
        const rules = {
            formData: {
                LKStatus: { required },
                ID: { required },
            },
        };
        const v$ = useVuelidate(rules, { formData });
        const openContractModal = () => {
            showContractModal.value = true;
        };
        const closeContractModal = (payload) => {
            if (payload?.refresh) {
                emit('refresh-config');
            }
            showContractModal.value = false;
            selectedContract.value = undefined;
        };
        const handleClickContract = (contract) => {
            selectedContract.value = contract;
            openContractModal();
        };
        const handleSave = async () => {
            store.dispatch('setIsLoading', true);
            try {
                const payload = { type: 'kronosRegion', ...formData };
                const response = await httpClient.post('/config/create', payload);
                if (response.data.statusCode === 500)
                    throw new Error();
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: props.selectedItem ? 'Changes saved' : 'Successfully created new region',
                });
                emit('refresh-config');
                emit('close-modal');
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: props.selectedItem ? 'Error saving changes' : 'Could not create region',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        onMounted(() => {
            if (props.selectedItem) {
                Object.assign(formData, props.selectedItem);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("form", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _hoisted_6,
                                    _createTextVNode(),
                                    _createElementVNode("fieldset", _hoisted_7, [
                                        _hoisted_8,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_9, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([true, false], (item) => {
                                                return _createElementVNode("div", {
                                                    key: item,
                                                    class: "flex items-center mr-6"
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        id: `LKStatus-${item.toString()}`,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.LKStatus) = $event)),
                                                        value: item,
                                                        name: `LKStatus-${item.toString()}`,
                                                        type: "radio",
                                                        checked: formData.LKStatus === item,
                                                        class: "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                                    }, null, 8, _hoisted_10), [
                                                        [_vModelRadio, formData.LKStatus]
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("label", {
                                                        for: `LKStatus-${item.toString()}`,
                                                        class: "ml-3 block text-sm font-medium text-gray-700"
                                                    }, _toDisplayString(item.toString()), 9, _hoisted_11)
                                                ]);
                                            }), 64))
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_14, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "kronos-region-id",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.ID) = $event)),
                                            type: "text",
                                            name: "kronos-region-id",
                                            class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:text-gray-800 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            disabled: !!_ctx.selectedItem,
                                            onBlur: _cache[2] || (_cache[2] = ($event) => (_unref(v$).formData.ID.$touch()))
                                        }, null, 40, _hoisted_15), [
                                            [_vModelText, formData.ID]
                                        ]),
                                        _createTextVNode(),
                                        (_unref(v$).formData.ID?.$error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createElementVNode("p", _hoisted_17, "* " + _toDisplayString(_unref(v$).formData.ID.$errors[0].$message), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_18, [
                                    _hoisted_19,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_20, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "kronos-region-label",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((formData.Label) = $event)),
                                            type: "text",
                                            name: "kronos-region-label",
                                            class: "block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm disabled:text-gray-800 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                            disabled: !!_ctx.selectedItem
                                        }, null, 8, _hoisted_21), [
                                            [_vModelText, formData.Label]
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_22
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.selectedItem)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                            onClick: _withModifiers(openContractModal, ["prevent"])
                                        }, "\n                Add Contract\n              ")
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.selectedItem?.CONTRACTS?.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                            _createElementVNode("table", _hoisted_27, [
                                                _createElementVNode("tbody", _hoisted_28, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItem.CONTRACTS, (contract) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                            key: contract.ID,
                                                            class: "cursor-pointer",
                                                            onClick: _withModifiers(($event) => (handleClickContract(contract)), ["prevent"])
                                                        }, [
                                                            _createElementVNode("td", _hoisted_30, [
                                                                _createTextVNode(_toDisplayString(contract.Label || contract.ID) + " ", 1),
                                                                (!contract.LKStatus)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "\n                        Inactive\n                      "))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ], 8, _hoisted_29));
                                                    }), 128))
                                                ])
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_32, "No Contracts exist in this Region."))
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_33, "You can only add Contracts once this Region has been saved."))
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 hover:underline",
                                onClick: _cache[4] || (_cache[4] = ($event) => (emit('close-modal')))
                            }, "\n            Cancel\n          "),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                disabled: _unref(v$).$invalid,
                                type: "submit",
                                class: "ml-3 inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _withModifiers(handleSave, ["prevent"])
                            }, "\n            Save\n          ", 8, _hoisted_36)
                        ])
                    ])
                ]),
                _createTextVNode(),
                (showContractModal.value)
                    ? (_openBlock(), _createBlock(ModalWindow, {
                        key: 0,
                        size: "5xl",
                        onClose: closeContractModal
                    }, {
                        icon: _withCtx(() => [
                            _createVNode(_unref(ClockIcon), {
                                class: "h-10 w-12 text-green-600",
                                "aria-hidden": "true"
                            })
                        ]),
                        title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedContract.value ? 'Edit Contract' : 'Add Contract'), 1)
                        ]),
                        subtitle: _withCtx(() => [
                            _createTextVNode("Please fill out the contract details")
                        ]),
                        main: _withCtx(() => [
                            _createVNode(KronosContractForm, {
                                "region-id": _ctx.selectedItem?.ID,
                                "selected-item": selectedContract.value,
                                onCancel: closeContractModal
                            }, null, 8, ["region-id", "selected-item"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
